/* eslint-disable import/named */
import {
    ITwitchRepository,
    TwitchResponStream,
    FetchPostsPayload,
    SearchTwitchUserRequest,
    SearchTwitchUserResponse,
} from 'lib/domain/twitch/interface';

import { HTTPService } from '@lib/infra/HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class TwitchRepository implements ITwitchRepository {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async getUserVideos(payload: FetchPostsPayload): Promise<any> {
        const url = 'twitch/videos';
        const res = await this.httpService.get({
            url,
            data: payload,
        });

        const { data } = res;

        return data;
    }
    async getUserClips(payload: FetchPostsPayload): Promise<any> {
        const url = 'twitch/clips';
        const res = await this.httpService.get({
            url,
            data: payload,
        });

        const { data } = res;

        return data;
    }
    async getStreams(payload: FetchPostsPayload): Promise<TwitchResponStream> {
        const url = 'twitch/streams';
        const res = await this.httpService.get({
            url,
            data: payload,
        });

        const { data } = res;

        return data;
    }

    async searchUser(
        req: SearchTwitchUserRequest,
    ): Promise<SearchTwitchUserResponse> {
        const url = 'twitch/users';
        const res = await this.httpService.get({
            url,
            data: req,
        });
        const { data } = res;
        return data;
    }
}
